import { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const ConstructionBanner = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <Box
      sx={{
        backgroundColor: "#fff3cd",
        color: "#856404",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        padding: "0.7rem",
        borderBottom: "1px solid #f5c6cb",
        mt: 2,
      }}
    >
      <Typography>
        ⚠️ Deze website is nog in opbouw – bedankt voor uw begrip! Rapporteer problemen aan wout.van.brussel@hotmail.com
      </Typography>
      <IconButton onClick={() => setVisible(false)} size="small">
        <CloseIcon />
      </IconButton>
    </Box>
  );
};
